import styled from 'styled-components'

const StyledEditableTextActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .ant-btn-circle {
    min-width: 26px;
  }

  .ant-btn-icon-only {
    width: 26px;
    height: 26px;
    font-size: 14px;
  }
`

export default StyledEditableTextActionButtonsContainer
